import React, {memo, useMemo} from "react"
import {PasswordContainer} from "../../../../components/PasswordContainer"
import {SubMenuComponent} from "../../../../components/SubMenu"
import iconLogs from "../../../../assets/images/icons/settings/log.png"
import {SettingsPageContainer} from "../../../../components/Settings/SettingsPageContainer"
import {useLocalization} from "../../../../hooks/localization"

export const LogScreen = memo(function LogScreen() {
    const {t} = useLocalization()
    const LogMenuRoutes = useMemo(
        () => [
            {
                icon: iconLogs,
                name: t("logs_page.user_logs"),
                path: "/settings/logs/user-logs"
            },
            {
                icon: iconLogs,
                name: t("logs_page.call_logs"),
                path: "/settings/logs/call-logs"
            },
            {
                icon: iconLogs,
                name: t("logs_page.boot_logs"),
                path: "/settings/logs/boot-logs"
            },
            {
                icon: iconLogs,
                name: t("logs_page.error_logs"),
                path: "/settings/logs/error-logs"
            },
            {
                icon: iconLogs,
                name: t("logs_page.service_alarm_logs"),
                path: "/settings/logs/service-alarm-logs"
            },
            {
                icon: iconLogs,
                name: t("logs_page.alarm_logs"),
                path: "/settings/logs/alarm-logs"
            },
            {
                icon: iconLogs,
                name: t("logs_page.mapping_logs"),
                path: "/settings/logs/mapping-logs"
            },
            {
                icon: iconLogs,
                name: t("logs_page.rf_test_logs"),
                path: "/settings/logs/rftest-logs"
            },
            {
                icon: iconLogs,
                name: t("logs_page.notification_logs"),
                path: "/settings/logs/notification-logs"
            }
        ],
        [t]
    )
    return (
        <PasswordContainer requiredRole="admin" isFullscreen={true}>
            <SettingsPageContainer buttons={[]} className="service-edit" backUrl={"/settings"}>
                <div className="content-divider">
                    <div className="sub-menu-content-divider">
                        {LogMenuRoutes.map(item => (
                            <SubMenuComponent icon={item.icon} name={item.name} path={item.path} />
                        ))}
                    </div>
                </div>
            </SettingsPageContainer>
        </PasswordContainer>
    )
})
